import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const faqs = [
  {
    question: "What makes the Perfect Pass different from other keratin irons?",
    answer: "The Winamor Perfect Pass is Australia's first hair straightener with built-in pass counting technology. It automatically tracks and displays the number of passes on an LCD screen, then vibrates to alert you when you've completed the set number. This ensures consistent keratin treatment results every time and prevents over-processing or under-treating hair sections."
  },
  {
    question: "Can I use it as a normal straightener without the pass counting?",
    answer: "Absolutely! With a single button press, you can switch off the counting mode and vibration alerts. The Perfect Pass works as a premium professional straightener with precise temperature control from 70°C to 230°C. It's perfect for everyday styling, curling, and smoothing."
  },
  {
    question: "What keratin treatments is the Perfect Pass compatible with?",
    answer: "The Perfect Pass is designed to work with all major keratin treatment types including Nano Keratin, No Yellow for Blondes, Gold Caviar treatments, Brazilian Blowouts, Japanese Straightening, and Express Smoothing treatments. The customizable pass count (3-30) allows you to match any brand's specific requirements."
  },
  {
    question: "How does shipping work?",
    answer: "We ship Australia-wide only. Shipping costs between $10-$15 AUD depending on your location and is calculated at checkout. Most orders are dispatched within 1-2 business days and delivered within 3-7 business days. You'll receive tracking information via email once your order ships."
  },
  {
    question: "What is your returns policy?",
    answer: "We offer a 30-day return policy for unused items in original packaging. Return shipping costs are the responsibility of the customer. To initiate a return, please fill out our Returns Form in the Support section. For warranty claims on defective products, please contact us first."
  },
  {
    question: "How does the trade-in program work?",
    answer: "Trade in your old hair straightener (any brand, any condition) and receive $100 off the Perfect Pass. Simply select the 'Trade-In' option at checkout. We'll include a prepaid return label with your new iron, and you can send back your old device within 30 days. It's our way of promoting sustainability and making professional tools more accessible."
  },
  {
    question: "What warranty comes with the Perfect Pass?",
    answer: "Every Perfect Pass comes with a standard 1-year warranty from the date of purchase. You can extend this to 3 years FREE by registering your product within 14 days of purchase using our Extended Warranty Form. The warranty covers any manufacturing defects, and we offer full replacement or repair at no cost."
  },
  {
    question: "Is the Perfect Pass suitable for home use or just salons?",
    answer: "Both! While it's designed by professional hairdressers for salon use, the Perfect Pass is equally perfect for home users. The gentle temperature settings (starting at 70°C) make it ideal for younger or delicate hair, while the pass counting helps prevent heat damage from over-straightening."
  },
  {
    question: "What's included in the Keratin Masterclass?",
    answer: "The VIP Masterclass includes hands-on training in 4 keratin treatment types (Nano Keratin, No Yellow for Blondes, Gold Caviar, Express Smoothing), a professional certification to display in your salon, an Income Accelerator Guide, Social Media Content Kit with ready-to-post templates, priority seating closer to the stage, networking opportunities, exclusive photo with the founder, and a $50 product credit voucher. Total value $2,178!"
  },
  {
    question: "What are the full specifications of the Perfect Pass?",
    answer: "Temperature range: 70-230°C (adjustable in 10°C increments) | Pass count: 3-30 passes | Heat-up time: 18 seconds | Plate size: 1.18 inches | Cord length: 3m | Voltage: 100-240V (worldwide compatible) | Weight: 240g | Features: LCD display, vibration alert, dual mode (counter/normal), auto shut-off after 30 minutes."
  }
];

export const FAQ = () => {
  return (
    <section className="section bg-[#0F0720] relative overflow-hidden">
      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <span className="text-purple-400 text-sm font-semibold uppercase tracking-wider mb-4 block">
            Got Questions?
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Frequently Asked <span className="text-gradient italic">Questions</span>
          </h2>
          <p className="text-purple-200 text-lg max-w-2xl mx-auto">
            Everything you need to know about the Perfect Pass keratin iron and our services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="faq-item border-none"
              >
                <AccordionTrigger className="px-6 py-4 text-left text-white hover:text-purple-300 hover:no-underline [&[data-state=open]]:text-purple-300">
                  <span className="font-semibold pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-purple-200">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          
          {/* Still have questions CTA */}
          <div className="mt-10 text-center p-6 glass-card">
            <p className="text-white font-semibold mb-2">Still have questions?</p>
            <p className="text-purple-300 text-sm mb-4">
              Our team responds within 4 hours during business hours.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a 
                href="#contact" 
                className="btn-primary inline-flex items-center justify-center px-6 py-2 rounded-full text-sm"
              >
                Contact Us
              </a>
              <a 
                href="#masterclass" 
                className="btn-secondary inline-flex items-center justify-center px-6 py-2 rounded-full text-sm"
              >
                Learn About Masterclass
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
